<template>
    <div class="relative group/notificationcontainer">
        <!-- The notification that the contextMenu belongs to -->
        <div @contextmenu.prevent="$emit('open')">
            <slot name="notification" />
        </div>

        <div
            v-if="!disableContextMenu"
            :class="[
                buttonTransition
                    ? 'rounded-xl pr-2 transition-sequence'
                    : 'rounded-[50%] pr-0 opacity-0 group-hover/notificationcontainer:opacity-100 transition-sequence-reverse',
                'absolute z-10 -translate-y-1/2 top-1/2 right-2 flex items-center bg-white shadow-md ring-1 ring-black/20 w-fit',
            ]"
        >
            <BoxTransition :show="showContentTransition">
                <div class="px-2 py-2 flex flex-col items-start gap-y-1">
                    <!-- The contents of the menu -->
                    <slot name="notification-actions" />
                </div>
            </BoxTransition>

            <button
                @click="open ? $emit('close') : $emit('open')"
                class="p-1 hover:bg-gray-100 transition-colors duration-button-hover h-fit rounded-full"
            >
                <component
                    :is="open ? 'PhX' : 'PhDotsThreeVertical'"
                    class="w-8 h-8"
                    :weight="open ? 'light' : 'bold'"
                >
                </component>
            </button>
        </div>
        <!-- An invisible overlay that is behind the contextmenu that fills the notificationpopover. Will close the notification menu on click -->
        <Teleport to="#notifications-menu" v-if="open && !disableContextMenu">
            <div
                @click="$emit('close')"
                @contextmenu.prevent="$emit('close')"
                class="absolute top-0 left-0 w-full h-full z-5"
            />
        </Teleport>
    </div>
</template>

<script>
import BoxTransition from '@/Components/Transitions/BoxTransition.vue'
import { PhDotsThreeVertical, PhX } from '@phosphor-icons/vue'

export default {
    emits: ['open', 'close'],
    components: {
        BoxTransition,
        PhDotsThreeVertical,
        PhX,
    },

    data() {
        return {
            showContentTransition: false,
            buttonTransition: false,
        }
    },

    watch: {
        open() {
            if (this.open) {
                this.buttonTransition = this.open
                setTimeout(() => {
                    this.showContentTransition = this.open
                }, 50)
            } else {
                this.showContentTransition = this.open
                this.buttonTransition = this.open
            }
        },
    },

    props: {
        open: {
            type: Boolean,
            required: true,
        },
        disableContextMenu: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
<style scoped>
/* Sequential transition for forward direction */
.transition-sequence {
    transition: border-radius 200ms ease-in-out, padding 200ms ease-in-out,
        opacity 200ms ease-in-out;
}

/* Sequential transition for reverse direction */
.transition-sequence-reverse {
    transition: padding 200ms ease-in-out, border-radius 200ms ease-in-out 150ms,
        opacity 200ms ease-in-out;
}
</style>
